import permissionsApi from '../api/permissions';
import useApiQuery from './common/useApiQuery';

export default function usePermissions(permissionType = '') {
  const { data, error, isLoading } = useApiQuery(
    ['userPermissions', permissionType],
    () => permissionsApi.getUserPermissions(permissionType),
    { enabled: !!permissionType || permissionType === '' }
  );

  const { permissions } = data || {};

  return { permissions, error, isLoading };
}
